import React from 'react';
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinus } from '@fortawesome/free-solid-svg-icons';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Link } from 'react-router-dom';
import Select from '../../../components/Select/Select';
import MultiSelect from '../../../components/Select/MultiSelect';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';

const MAX_FILE_SIZE_MB = 2.5; // 2.5 MB
const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'];

const SyllabusForm = ({
  changeHandler,
  submitHandler,
  fileUploadHandler,
  id,
  classAddHandler,
  classRemoveHandler,
  programData,
  subjectData,
  program_ids,
  data,
  addRow,
  clickOnDelete,
}) => {

  // 🔍 File validation handler
  const handleFileValidation = (e, idx) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check file size
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert(`❌ File size cannot exceed ${MAX_FILE_SIZE_MB} MB.`);
      e.target.value = null;
      return;
    }

    // Check file type
    if (!ALLOWED_TYPES.includes(file.type)) {
      alert("❌ Invalid file type. Only PDF and image files are allowed.");
      e.target.value = null;
      return;
    }

    fileUploadHandler(e, idx);
  };

  return (
    <Form onSubmit={submitHandler}>
      {/* 🔹 Class Selection */}
      <div className="col-md-12">
        <Form.Group>
          <Form.Label>Class</Form.Label>
          <MultiSelect
            name="program_ids"
            options={programData}
            id={program_ids}
            onRemove={classRemoveHandler}
            onSelect={classAddHandler}
            displayValue="name"
            selectedValues={program_ids}
            closeOnSelect={false}
            placeholder="Select Class"
          />
        </Form.Group>
      </div>

      {/* 🔹 Dynamic Syllabus Rows */}
      {data && data.map((val, idx) => (
        <div className="row mt-2 syllbus" key={idx}>
          <div className="col-md-6">
            <Select
              label="Subject"
              name="subject_id"
              value={val.subject_id}
              onChangeHandler={(e) => changeHandler(e, idx)}
              options={subjectData}
              placeholder="Select Subject"
            />
          </div>

          <div className="col-md-5">
            <Input
              label="Syllabus Docs File"
              type="file"
              name="syllabus_docs"
              accept=".pdf, image/*"
              onChangeHandler={(e) => handleFileValidation(e, idx)}
            />
            {id && val.syllabus_docs && (
              <Link to={val.syllabus_docs} target="_blank" className="d-block mt-1">
                View File
              </Link>
            )}
          </div>

          {!id && (
            <div className="col-md-1 d-flex align-items-end">
              {idx === 0 ? (
                <Button
                  variant="success"
                  type="button"
                  onClick={addRow}
                  className="text-center"
                  title="Add Row"
                >
                  <FontAwesomeIcon icon={faPlusCircle} />
                </Button>
              ) : (
                <Button
                  variant="danger"
                  type="button"
                  onClick={(e) => clickOnDelete(e, val)}
                  title="Remove Row"
                >
                  <FontAwesomeIcon icon={faMinus} />
                </Button>
              )}
            </div>
          )}

          <div className="col-md-12 mt-3">
            <Form.Group>
              <Form.Label>Syllabus Description</Form.Label>
            </Form.Group>
            <CKEditor
              editor={ClassicEditor}
              data={val.syllabus_desc}
              onChange={(event, editor) => {
                const data = editor.getData();
                changeHandler({ target: { name: 'syllabus_desc', value: data } }, idx);
              }}
            />
          </div>
        </div>
      ))}

      {/* 🔹 Submit Button */}
      <div className="row d-flex justify-content-end mt-3">
        <div className="col-md-2 text-end">
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default React.memo(SyllabusForm);

